import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-navigation-right-2-icon',
  templateUrl: './navigation-right-2.component.html'
})
export class NavigationRight2Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
